import { CheckIcon, WarningIcon } from "@chakra-ui/icons";
import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import { TARM_AWS_URL } from "../../api/api";

const JobProfileName = ({
  getJobProfileName,
  getIsJobProfileNameAvailable,
}) => {
  const [source] = useState(axios.CancelToken.source());
  const [jobProfileName, setJobProfileName] = useState("");
  const [isJobProfileNameLoading, setIsJobProfileNameLoading] = useState(false);
  const [isJobProfileNameAvailable, setIsJobProfileNameAvailable] =
    useState(true);
  const toast = useToast()

  const jobProfileNameOnBlur = async (event) => {
    if (jobProfileName) {
      setIsJobProfileNameLoading(true);
      try {
        const response = await TARM_AWS_URL.post(
          "jd-parser/jd-exists",
          {
            jdname: jobProfileName.toLowerCase(),
          },
          {
            cancelToken: source.token,
          }
        );
        console.log(response.data);
        if (response.data === "Y") {
          setIsJobProfileNameAvailable(false);
          getIsJobProfileNameAvailable(false);
        } else {
          setIsJobProfileNameAvailable(true);
          getIsJobProfileNameAvailable(true);
          getJobProfileName(jobProfileName);
        }
      } catch (error) {
        console.log(`Error: ${error.message}`);
        toast({
          title: error.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setIsJobProfileNameLoading(false);
      }
    }
  };

  const jobProfileNameChangeHandler = (event) => {
    // Remove all dots and replace spaces with underscores
    const sanitizedValue = event.target.value.replace(/[.]/g, '').replace(/\s/g, '_');
    setJobProfileName(sanitizedValue)
  }

  return (
    <FormControl mt={4} isRequired>
      <FormLabel htmlFor="jobProfileName">
        Name of the job profile
      </FormLabel>
      <InputGroup>
        <Input
          id="jobProfileName"
          type="text"
          autoComplete="off"
          autoFocus
          value={jobProfileName}
          onChange={jobProfileNameChangeHandler}
          onBlur={jobProfileNameOnBlur}
        />

        {jobProfileName && isJobProfileNameLoading && (
          <InputRightElement children={<Spinner color="blue.500" />} />
        )}

        {jobProfileName &&
          !isJobProfileNameLoading &&
          isJobProfileNameAvailable && (
            <InputRightElement children={<CheckIcon color="green.500" />} />
          )}

        {jobProfileName &&
          !isJobProfileNameLoading &&
          !isJobProfileNameAvailable && (
            <Tooltip
              hasArrow
              label={`Job profile with name ${jobProfileName} already exists`}
              bg="red.500"
              color="white"
            >
              <InputRightElement children={<WarningIcon color="red.500" />} />
            </Tooltip>
          )}
      </InputGroup>
    </FormControl>
  );
};

export default JobProfileName;
